import { TEMPLATE_VERSIONS_COLUMN_ID } from "../constants";
import TemplatesTableRowActionsCell from "./RowActionsCell";
import TemplatesTableNameCell from "./NameCell";
import TemplatesTableDescriptionCell from "./DescriptionCell";
import TemplatesLatestVersionCell from "./LatestVersionCell";

export const TEMPLATE_VERSIONS_TABLE_CELLS = {
  [TEMPLATE_VERSIONS_COLUMN_ID.STATE]: TemplatesTableNameCell,
  [TEMPLATE_VERSIONS_COLUMN_ID.DESCRIPTION]: TemplatesTableDescriptionCell,
  [TEMPLATE_VERSIONS_COLUMN_ID.LATEST_VERSION]: TemplatesLatestVersionCell,
  [TEMPLATE_VERSIONS_COLUMN_ID.DROPDOWN]: TemplatesTableRowActionsCell,
};
